<template>
  <div
    v-if="stats && stats.approved > 0"
    class="entity-details-card px-6 py-5 mt-5"
    style="max-width: 480px"
  >
    <p class="has-text-weight-bold mb-3">
      {{ $t("mp:dashboard.prescore_conversion.title") }}
    </p>
    <p class="is-size-3 has-text-weight-bold">{{ stats.conversionRate }}%</p>
    <p class="has-text-grey">
      {{
        $t("mp:dashboard.prescore_conversion.detail", {
          converted: stats.converted,
          approved: stats.approved,
        })
      }}
    </p>
  </div>
</template>

<script>
import network from "../../utils/network";

const PERIOD_DAYS = 30;

/**
 * Pay with prescore: share of the merchant's approved convertible prescores that customers bought.
 * Hidden for merchants without any.
 */
export default {
  name: "PreScoreConversionCard",
  data() {
    return {
      stats: null,
    };
  },
  async mounted() {
    const to = new Date();
    const from = new Date(to.getTime() - PERIOD_DAYS * 24 * 60 * 60 * 1000);
    try {
      const axios = await network.connection();
      const { data } = await axios.get(
        "/bnpl/pre-score/merchant/conversion-stats",
        { params: { from: from.toISOString(), to: to.toISOString() } }
      );
      this.stats = data;
    } catch (e) {
      this.stats = null;
    }
  },
};
</script>
